import React, { useState } from 'react';
import './App.css';
import { handleStripePayment, formatPrice } from './utils/payment';

function App() {
  const [loading, setLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);

  const formations = [
    {
      id: 1,
      title: "Prise de masse",
      price: 25,
      description: "Programme complet de 11 jours pour développer votre masse musculaire avec des exercices ciblés et une nutrition adaptée.",
      features: [
        "Plan d'entraînement détaillé par email",
        "Programme de musculation complet",
        "Guide nutritionnel inclus",
        "Exercices expliqués étape par étape",
        "Formation de 11 jours",
        "Format PDF téléchargeable"
      ]
    },
    {
      id: 2,
      title: "Sèche + Nutrition",
      price: 25,
      description: "Programme complet de 11 jours pour perdre du poids et sculpter votre physique avec nutrition personnalisée.",
      features: [
        "Plan d'entraînement sèche par email",
        "Guide nutritionnel complet",
        "Exercices de cardio optimisés",
        "Menu type et conseils alimentaires",
        "Formation de 11 jours",
        "Format PDF téléchargeable"
      ]
    },
    {
      id: 3,
      title: "Entraînement militaire police pompier",
      price: 50,
      description: "Préparation physique complète de 11 jours pour les concours et métiers exigeants avec Coach Hassan.",
      features: [
        "Programme d'entraînement spécialisé par email",
        "Préparation aux tests physiques officiels",
        "Exercices d'endurance et résistance",
        "Entraînement mental et discipline",
        "Formation de 11 jours",
        "Tests d'évaluation inclus",
        "Format PDF téléchargeable",
        "Conseils de préparation aux concours"
      ],
      popular: true
    }
  ];

  const handlePurchase = (formationId, formationTitle) => {
    setLoading(true);
    setPaymentStatus(null);
    
    try {
      const result = handleStripePayment(formationId);
      
      if (result.success) {
        // Show success message briefly before redirect
        setPaymentStatus('success');
        setTimeout(() => setPaymentStatus(null), 3000);
      } else {
        setPaymentStatus('error');
        alert(`Erreur: ${result.error}`);
        setTimeout(() => setPaymentStatus(null), 5000);
      }
    } catch (error) {
      console.error('Payment error:', error);
      setPaymentStatus('error');
      setTimeout(() => setPaymentStatus(null), 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      {/* Payment Status Notification */}
      {paymentStatus && (
        <div className={`payment-status ${paymentStatus}`}>
          {paymentStatus === 'success' ? 
            '✓ Paiement réussi! Merci pour votre achat.' : 
            '✗ Erreur de paiement. Veuillez réessayer.'
          }
        </div>
      )}

      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo-section">
              <h1 className="logo">Hassan Formations</h1>
              <p className="tagline">Coach sportif professionnel - Transformation physique</p>
            </div>
            <nav className="navigation">
              <a href="#formations">Programmes</a>
              <a href="#coach">Coach Hassan</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <img src="/Home.png" alt="Entraînement fitness" className="hero-image" />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Transformez votre physique avec Coach Hassan
            </h1>
            <p className="hero-description">
              Programmes d'entraînement personnalisés pour atteindre vos objectifs : sèche, prise de masse, ou préparation physique professionnelle.
            </p>
            <a href="#formations" className="cta-button">
              Découvrir mes programmes
            </a>
          </div>
        </div>
      </section>

      {/* Coach Section */}
      <section id="coach" className="coach-section">
        <div className="container">
          <div className="coach-content">
            <div className="coach-image-container">
              <img src="/coach.png" alt="Coach Hassan" className="coach-image" />
            </div>
            <div className="coach-info">
              <h2>Votre Coach Hassan</h2>
              <p className="coach-description">
                Coach sportif professionnel spécialisé dans la transformation physique et la préparation aux concours. 
                Fort de plusieurs années d'expérience, je vous accompagne dans l'atteinte de vos objectifs avec des méthodes éprouvées.
              </p>
              <div className="coach-specialties">
                <h3>Mes spécialités :</h3>
                <ul>
                  <li>🏋️ Prise de masse musculaire</li>
                  <li>🔥 Programme de sèche</li>
                  <li>🚔 Préparation physique militaire/police/pompier</li>
                  <li>💪 Transformation physique complète</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Formations Section */}
      <section id="formations" className="formations-section">
        <div className="container">
          <h2 className="section-title">Mes Programmes d'Entraînement</h2>
          <p className="section-subtitle">Choisissez le programme adapté à vos objectifs</p>
          <div className="formations-grid">
            {formations.map((formation) => (
              <div key={formation.id} className={`formation-card ${formation.popular ? 'popular' : ''}`}>
                {formation.popular && <div className="popular-badge">Plus populaire</div>}
                <div className="formation-header">
                  <h3 className="formation-title">{formation.title}</h3>
                  <div className="formation-price">
                    <span className="currency">€</span>
                    <span className="amount">{formation.price}</span>
                  </div>
                </div>
                <p className="formation-description">{formation.description}</p>
                <ul className="features-list">
                  {formation.features.map((feature, index) => (
                    <li key={index} className="feature-item">
                      <span className="check-icon">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button 
                  className="purchase-button"
                  onClick={() => handlePurchase(formation.id, formation.title)}
                  disabled={loading}
                >
                  {loading && <span className="loading-spinner"></span>}
                  {loading ? 'Traitement...' : `Acheter maintenant - ${formatPrice(formation.price)}`}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>Hassan Formations</h4>
              <p>Votre coach sportif pour une transformation physique réussie.</p>
              <p>Programmes personnalisés et suivi professionnel.</p>
              <p>Paiements sécurisés avec Stripe</p>
            </div>
            <div className="footer-section">
              <h4>Programmes disponibles</h4>
              <p>Prise de masse - €25</p>
              <p>Sèche + Nutrition - €25</p>
              <p>Entraînement militaire - €50</p>
            </div>
            <div className="footer-section">
              <h4>Informations légales</h4>
              <a href="#mentions">Mentions légales</a>
              <a href="#privacy">Politique de confidentialité</a>
              <a href="#refund">Politique de remboursement</a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Hassan Formations. Tous droits réservés.</p>
            <p>Paiements sécurisés par Stripe</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
